/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Clear_SpeakersInputs */

const en_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Speakers`)
};

const fr_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les locuteurs`)
};

const de_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Speakers`)
};

const it_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altoparlanti chiari`)
};

const ru_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чистые динамики`)
};

const es_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altavoces claros`)
};

const zh_cn2_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清晰的扬声器`)
};

const ja_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリアなスピーカー`)
};

const hi_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लियर स्पीकर`)
};

const pt_pt2_context_menu_clear_speakers = /** @type {(inputs: Context_Menu_Clear_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto-falantes nítidos`)
};

/**
* | output |
* | --- |
* | "Clear Speakers" |
*
* @param {Context_Menu_Clear_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_clear_speakers = /** @type {((inputs?: Context_Menu_Clear_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Clear_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_clear_speakers(inputs)
	if (locale === "de") return de_context_menu_clear_speakers(inputs)
	if (locale === "it") return it_context_menu_clear_speakers(inputs)
	if (locale === "ru") return ru_context_menu_clear_speakers(inputs)
	if (locale === "es") return es_context_menu_clear_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_clear_speakers(inputs)
	if (locale === "ja") return ja_context_menu_clear_speakers(inputs)
	if (locale === "hi") return hi_context_menu_clear_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_clear_speakers(inputs)
	return en_context_menu_clear_speakers(inputs)
});